import Map from 'ol/Map.js';
// import StadiaMaps from 'ol/source/StadiaMaps.js';
import OSM from 'ol/source/OSM.js';
import MVT from 'ol/format/MVT.js';
import VectorSource from 'ol/source/Vector.js';
import View from 'ol/View.js';
import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from 'ol/style.js';
import { Layer, Tile as TileLayer, Vector as VectorLayer } from 'ol/layer.js';
import { Feature, Overlay, VectorTile } from 'ol';
import { Point } from 'ol/geom';
import { fromLonLat } from 'ol/proj';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';


window.initMap = function (coordinates, markers = [], selector = 'map') {

	// const styleCache = {};
	// const styleFunction = function (feature) {
	// 	const radius = 5 + 10 * 0.2;
	// 	let style = styleCache[radius];
	// 	if (!style) {
	// 		style = new Style({
	// 			image: new CircleStyle({
	// 				radius: radius,
	// 				fill: new Fill({
	// 					color: 'rgba(201, 37, 38, 0)',
	// 				}),
	// 				stroke: new Stroke({
	// 					color: 'rgba(201, 37, 38, 1)',
	// 					width: 3,
	// 				}),
	// 			}),
	// 		});
	// 		styleCache[radius] = style;
	// 	}
	// 	return style;
	// };


	const markersLayer = markers.length > 0 ?
		new VectorLayer({
			source: new VectorSource({
				features: markers.map(marker =>
					new Feature({
						geometry: new Point(fromLonLat(marker.coordinates)),
						title: marker?.title ?? '',
						slug: marker?.slug ?? '',
					})
				)
			}),
			// style: styleFunction,
			style: new Style({
				image: new Icon({
					anchor: [0.5, 1],
					scale: 0.05,
					src: new URL('/resources/images/marker.png', import.meta.url).href,
				}),
			}),
		}) :
		null


	const styles = {
		light: new Style({
			fill: new Fill({
				color: '#6f623e'
			}),
			stroke: new Stroke({
				color: '#ffffff',
				width: 0.5
			}),
			// text: new Text({
			// 	font: '12px Calibri,sans-serif',
			// 	textBaseline: 'top',
			// 	offsetY: 2
			// })
		}),
		dark: new Style({
			fill: new Fill({
				color: '#2f3926'
			}),
			stroke: new Stroke({
				color: '#ffffff',
				width: 0.5
			}),
		})
	};

	const osmLayer = new VectorTileLayer({
		declutter: true,
		source: new VectorTileSource({
			format: new MVT(),
			url: 'https://basemaps.arcgis.com/arcgis/rest/services/World_Basemap_v2/VectorTileServer/tile/{z}/{y}/{x}.pbf',
		}),
		style: function (feature) {
			const type = feature.get('layer').split(' ')[0];
			// console.log(feature.get('_name_en'))
			// console.log(type)
			if (
				['City', 'Continent', 'Vegetation', 'Colormap'].includes(type) ||
				feature.get('layer') === 'Admin0 ribbon L2 L3 inner'
			) {
				if(styles.light.getText()) {
					styles.light.setText(feature.get('_name_en'));
				}
				return styles.light;
			} else if (['Marine', 'Ocean', 'Water'].includes(type)) {
				return styles.dark;
			} else if(type === 'Boundary') {
				return new Style({
					fill: new Fill({
						color: '#2f3926'
					}),
					stroke: new Stroke({
						color: '',
						width: 0.2
					}),
				});
			}
		},
	});


	const layers = [osmLayer];
	if(markersLayer) {
		layers.push(markersLayer);
	}

	const map = new Map({
		layers: layers,
		target: selector,
		view: new View({
			center: fromLonLat(coordinates),
			zoom: 3,
		}),
	});


	const tooltip = document.querySelector(`#${selector} #info`);
	const overlay = new Overlay({
		element: tooltip,
		offset: [10, 0],
		positioning: 'bottom-left',
	});
	map.addOverlay(overlay);

	const navigateByUri = (evt) => {
		const feature = map.forEachFeatureAtPixel(evt.pixel, (f) => f);
		if (feature && feature.get('slug')) {
			open(`${feature.get('slug')}`);
		}
	};

	const displayTooltip = (evt) => {
		const feature = map.forEachFeatureAtPixel(evt.pixel, (f) => f);
		tooltip.style.display = feature && feature.get('title') ? '' : tooltip.querySelector('a') ? '' : 'none';
		document.getElementById(`${selector}`).style.cursor = feature && feature.get('slug') ? 'pointer' : ''
		if (feature && feature.get('title')) {
			overlay.setPosition(evt.coordinate);
			tooltip.innerHTML = ` <p> ${feature.get('title')} </p> `
		}
	};

	map.on('click', navigateByUri);
	map.on('pointermove', displayTooltip);

	// map.on('postcompose',function(e){
	// 	document.querySelector('canvas').style.filter="grayscale(1)";
	// });
}
